import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
// import { confirm } from '@trueprodigy/components';
import Sticky from 'react-stickynode';

export const parseDate = date => {
  const dt = new Date(date);
  return `${dt.getMonth() + 1}/${dt.getDate()}/${dt.getFullYear()}`;
};

const OwnerHeader = ({
  alternateNamesID,
  ownerAlias,
  onClose
}) => (
  <Sticky innerZ={9} top={67}>
    <OwnerHeader.Banner>
      <OwnerHeader.CloseButton aria-label="Close" onClick={onClose}>
        <CloseIcon />
      </OwnerHeader.CloseButton>
      <OwnerHeader.BannerRow>
        <Typography variant="h6">
          {alternateNamesID && (
            <React.Fragment>
              {alternateNamesID}
            </React.Fragment>
          )}
        </Typography>
        <Typography variant="h5">{alternateNamesID ? 'EDIT' : 'NEW'} OWNER ALIAS</Typography>
      </OwnerHeader.BannerRow>
      {alternateNamesID && (
        <OwnerHeader.BannerRow>
          <OwnerHeader.Actions>
            <Tooltip
              title={`Updated On ${parseDate(ownerAlias.updateDt)} by ${
                ownerAlias.updatedBy
              } | Created On ${parseDate(ownerAlias.createDt)} by ${
                ownerAlias.createdBy
              }`}
              placement="left"
            >
              <InfoIcon />
            </Tooltip>
          </OwnerHeader.Actions>
        </OwnerHeader.BannerRow>
      )}
    </OwnerHeader.Banner>
  </Sticky>
);

OwnerHeader.propTypes = {
  ownerAlias: PropTypes.object.isRequired,
  alternateNamesID: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

OwnerHeader.Banner = styled.header`
  background: #3b5267;
  padding: 10px 40px 10px 20px;
  position: relative;
`;

OwnerHeader.CloseButton = styled(CloseIcon)`
  position: absolute;
  right: 3px;
  top: 3px;
  cursor: pointer;
  fill: #fff !important;
  font-size: 20px !important;
  font-weight: bold;
`;

OwnerHeader.BannerRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;

  > h6 {
    color: #fff;
  }

  > h5 {
    color: #fff;
    font-weight: bold;
    opacity: 0.5;
  }
`;

OwnerHeader.EventAttrName = styled.span`
  opacity: 0.5;
`;

OwnerHeader.EventAttrValue = styled.span`
  margin: 0 10px 0 5px;
`;

OwnerHeader.Actions = styled.div`
  display: flex;
  align-items: center;

  > svg {
    cursor: pointer;
    fill: #fff;
  }

  > button {
    padding: 2px;
    margin-left: 5px;
  }
`;

export default OwnerHeader;